import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from './generic.service';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracaoGeralService extends GenericService {

  constructor(http: HttpClient) {
    super(http, 'configuracao-geral');
  }

  atual(): Observable<any> {
    return this.http.get(`${this.url_base}/${this.prefixo}/atual`);
  }
}
